import axios from 'axios';

import type { ApplyClaimFlagsParams } from '~/server_shared/openapi/data-contracts';

export const applyClaimFlags = async (claimId: number, flagKeys: string[]): Promise<void> => {
  const body: ApplyClaimFlagsParams = { flag_keys: flagKeys };
  await axios.post(`/api/v1/claims/${claimId}/flags`, body);
};

export const removeClaimFlag = async (claimId: number, flagKey: string): Promise<void> => {
  await axios.delete(`/api/v1/claims/${claimId}/flags/${encodeURIComponent(flagKey)}`);
};
